module.exports = __webpack_public_path__ + "static/header-5c539163819d8dbd2269af49f354cb18.png";